import type { HasPermissionType } from '@quipex/core/auth';
import { PermissionKey } from '@quipex/shared/contracts';

export const MANAGE_ORGANISATION_USERS_PERMISSIONS = [
    PermissionKey.OrgUsersRead,
    PermissionKey.OrgUsersRoleUpdate,
] satisfies HasPermissionType;

export const MANAGE_ORGANISATION_USERS_ROUTE = '/organisation/users' as const;
